module.exports = "<header ng-class=\"{ 'mobile': $ctrl.isMobileApp }\">\n  <h2>{{ $ctrl.text }}</h2>\n</header>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/loans.module/components/sectionTitle/sectionTitle.html
// module id = 2155
// module chunks = 0